import { Outlet } from "react-router-dom";
// import Profile from "./Profile";
// import ClassProfile from "./ClassProfile"
import GitProfile from "./GitProfile";
const About =()=>{
     return(
          <div className="flex text-lg bg-slate-200">
          <h1 className="flex justify-center m-4 p-4 text-lg font-bold items-center">USER PROFILE</h1>
          
          {/* <Profile name={"saurabh"}/> */}
          {/* <ClassProfile name ={"singh"}/> */}
          <GitProfile name={"saurabh"} />
          </div>
     );
}
export default About;